import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../../../redux/profile/action";
import { Modal } from "reactstrap";
import ProfileModelSkills from "../ProfileModel/ProfileModelSkills";
import {
  getCategary,
  getDegree,
  getIndustry,
  getLanguage,
  getProficiency,
  getSkills,
} from "../../../../redux/categary/action";
import { GetCountry } from "../../../../redux/master/action";
import ProfileModelPortfolio from "../ProfileModel/ProfileModelPortfolio";
import ProfileModelLanguage from "../ProfileModel/ProfileModelLanguage";
import ProfileModelAcademicInfo from "../ProfileModel/ProfileModelAcademicInfo";
import ProfileModelEmployment from "../ProfileModel/ProfileModelEmployment";
import ProfileModelAbout from "../ProfileModel/ProfileModelAbout";
import ProfileModelImage from "../ProfileModel/ProfileModelProfile";
import ProfileModelIndustry from "../ProfileModel/ProfileModelIndustry";
import ProfileModelPrice from "../ProfileModel/ProfileModelPrice";
import ProfileModelProfile from "../ProfileModel/ProfileModelProfile";
import ProfileModelExpertAbout from "../ProfileModel/ProfileModelExpertAbout";
import ProfileModelCompanyAbout from "../ProfileModel/ProfileModelCompanyAbout";
import { companyRegistration } from "../../../../redux/company/action";
import { expertRegistration } from "../../../../redux/expert/action";
import ProfileModelCompanyPrice from "../ProfileModel/ProfileModelCompanyPrice";
import ButtonLoader from "../../../Common/Loader/ButtonLoader";
import ProfileModelBankDetails from "../ProfileModel/ProfileModelBankDetails";
import ProfileModelCategoerySubcategory from "../ProfileModel/ProfileModelCategoerySubcategory";
import { formatNumberWithCommas, maskAccountNumber } from "../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import ProfileIndustryModal from "../ProfileModel/ProfileIndustryModal";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import ImageWithFallback from "../../../../common/ImageWithFallback";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import RatingReviewsComponent from "../../../Common/RatingReviewsComponent";
import YearRange from "../../../Common/YearRange";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

export default function ManageExpertProfile({
  previousPage,
  edittype,
  formData,
  setFormData,
}) {
  const path = "Assets/scss/hireexpert.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileofuser = useSelector(
    ({ profile: { profiledata } }) => profiledata
  );
  const [catsubcat, setCatsubcat] = useState(false);
  const [industryModal, setIndustryModal] = useState(false);
  const [modalSkills, setModalSkills] = useState(false);
  const [modalportfolio, setModalPortfolio] = useState(false);
  const [modallanguage, setModalLanguage] = useState(false);
  const [modelAcademic, setModelAcademic] = useState(false);
  const [modelEmployment, setModelEmployment] = useState(false);
  const [modelAbout, setModelAbout] = useState(false);
  const [modelExpertAbout, setModelExpertAbout] = useState(false);
  const [modelCompanyAbout, setModelCompanyAbout] = useState(false);
  const [modelBank, setModelBank] = useState(false);
  const [modelImage, setModelImage] = useState(false);
  const [modelIndustry, setModelIndustry] = useState(false);
  const [modelPrice, setModelPrice] = useState(false);
  const [modelCompanyPrice, setModelCompanyPrice] = useState(false);
  const [modelProfile, setModelProfile] = useState(false);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    if (edittype == 1) {
      setFormData(profileofuser);
    } else {
      setFormData(formData);
    }
  }, [profileofuser, edittype]);

  useEffect(() => {
    dispatch(getIndustry());
    dispatch(getSkills());
    dispatch(getCategary());
    dispatch(getDegree());
    dispatch(getLanguage());
    dispatch(GetCountry());
    dispatch(getProficiency());
  }, [dispatch]);

  const hitapiandsubmitform = async () => {
    setLoading(true);
    try {
      let response;
      const { first_name, last_name, profile_image, ...filteredData } = formData;

      const finalData = {
        ...filteredData,
        first_name: first_name || profile?.first_name,
        last_name: last_name || profile?.last_name,
        profile_image: profile_image || profile?.profile_image,
      };

      if (formData.iam == 2) {
        response = await dispatch(companyRegistration(finalData, navigate));
        await new Promise((resolve) => setTimeout(resolve, 2000));
        if (response?.data?.status) {
          localStorage.setItem("role_type", response?.data?.response?.role_type);
          navigate(`/${lan}/account/UpgradeMembership`);
        }
      } else {
        response = await dispatch(expertRegistration(finalData, navigate));
        await new Promise((resolve) => setTimeout(resolve, 2000));
        if (response?.data?.status) {
          localStorage.setItem("role_type", response?.data?.response?.role_type);
          navigate(`/${lan}/account/UpgradeMembership`);
        }
      }
    } catch (error) {
      console.error("Something Went Wrong:", error);
    } finally {
      setLoading(false);
    }
  };

  const degreelistss = useSelector(
    ({ categary: { degreelist } }) => degreelist
  );
  const industrylist = useSelector(({ categary: { industrylist } }) => industrylist
  );

  const degreeOptions =
    Array.isArray(degreelistss) &&
    degreelistss.map((lang) => ({ value: lang.id, label: lang.title }));

  const flattenSubcategories = (categories) => {
    return categories?.flatMap((category) =>
      category.sub_categories.map((sub) => ({
        ...sub,
        categoryId: category.id,
        categoryTitle: category.title,
      }))
    );
  };

  const subcategoryArray = flattenSubcategories(formData?.categories);
  console.log(formData, 'formData');

  const StarRating = ({ rating }) => {
    const maxStars = 5;
    return (
      <div className="star-sec">
        {[...Array(maxStars)].map((_, i) => (
          <i
            key={i}
            className={i < rating ? "fa-solid fa-star" : "fa-solid fa-star disabled"}
          ></i>
        ))}
      </div>
    );
  };

  return (
    <div className="hire-details manage-profile  mx-auto">
      {edittype == 1 && <h2>Manage profile</h2>}
      <div className="expertdetail-first">
        <div className="expertdetail-row">
          <div className="expert-left">
            <div className="expert-leftprofile">

              <ProfileImageWithFallback url={formData?.profile_image == ""
                ? profileofuser?.profile_image ? profileofuser?.profile_image : ProfilePic
                : formData?.profile_image} />
              <button className="btn camera-icon">
                <img
                  onClick={() => setModelProfile(true)}
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/camera.svg`}
                  alt=""
                />
              </button>
            </div>
            <div>
              <h2 className="manage-head">
                {formData?.first_name == ""
                  ? profileofuser?.first_name
                  : formData?.first_name}{" "}
                &nbsp;
                {formData?.last_name == ""
                  ? profileofuser?.last_name
                  : formData?.last_name}
              </h2>

              <h6>
                {decodeHtml(formData?.expert?.designation == ""
                  ? profileofuser?.expert?.designation
                  : formData?.expert?.designation)}
                {(formData?.company?.cr_number || profileofuser?.company?.cr_number) ? "CR/Licensed No. : " : ""}
                {formData?.company?.cr_number == ""
                  ? profileofuser?.company?.cr_number
                  : formData?.company?.cr_number}
                <span>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`}
                    alt=""
                  />
                  {formData?.country_title == ""
                    ? profileofuser?.country_title
                    : formData?.country_title}
                </span>
              </h6>
              {/* {formData?.country_title &&
            <p className="">Location: {formData?.country_title} </p>
          } */}
              {formData?.email_id &&
                <p className="">Email : {formData?.email_id} </p>
              }
            </div>
          </div>
          {loading ? (
            <ButtonLoader />
          ) : (
            <div
              className="d-flex justify-content-end"
              style={{ columnGap: "20px" }}
            >
              {edittype != 1 && (
                <button
                  onClick={previousPage}
                  className="prev-button buttons border-button"
                  type="submit"
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
                    alt=""
                  />
                  Previous Page
                </button>
              )}
              {edittype != 1 && (
                <button
                  onClick={hitapiandsubmitform}
                  className="next-button w-auto buttons background-button"
                  type="submit"
                >
                  Save and submit profile
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                    alt=""
                  />
                </button>
              )}
            </div>
          )}

          {edittype == 1 && (
            <div className="expert-right">
              <button
                className="btn message-btn"
                onClick={() =>
                  navigate(`/${lan}/account/publicpreview/${formData?.id}`)
                }
              >
                Public Preview
              </button>
              <button
                className="btn active message-btn"
                onClick={() =>
                  navigate(`/${lan}/dashboard/manageprofile/settings`)
                }
              >
                Profile settings
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="expertdetail-second ">
        <div className="row">
          <div className="col-lg-3 col-md-4 expert-second-left d-flex flex-column" style={{ rowGap: '10px' }}>
            {/* <p className="about-me">
              {formData?.role_type == 4 || formData?.iam == 2
                ? "About Company"
                : ""}
              {formData?.role_type == 3 || formData?.iam == 1
                ? "About Expert"
                : ""}
            </p> */}

            <div className="about-expert">
              <h6>
                Industry, Category & Subcategory
                <a onClick={() => setCatsubcat(true)}>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>
                <h6>Industry : </h6>
                {formData?.industries?.map((item, index) => (
                  <>
                    <p key={index}>{item?.title}</p>
                  </>
                ))}
              </p>
              <p>
                <h6>Category : </h6>
                {formData?.categories?.map((item, index) => (
                  <>
                    <p key={index}>{item?.title}</p>
                  </>
                ))}
              </p>
              <p>
                <h6>Subcategory : </h6>
                {subcategoryArray?.map((item, index) => (
                  <>
                    <p key={index}>{item?.title}</p>
                  </>
                ))}
              </p>
            </div>

            <div className="about-expert">
              <h6>
                Language
                <a>
                  <img
                    onClick={() => setModalLanguage(true)}
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              {Array.isArray(formData?.language) &&
                formData?.language?.map((item, index) => (
                  <p key={index}>
                    {item?.language_title} - {item?.proficiency_title}
                  </p>
                ))}
            </div>

            {(formData?.expert || formData?.iam == 1) && (
              <>
                {formData?.iam == 2 ? (
                  ""
                ) : (
                  <div className="about-expert">
                    <h6>
                      Education
                      <a>
                        <img
                          onClick={() => setModelAcademic(true)}
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                          alt=""
                        />
                      </a>
                    </h6>
                    {Array.isArray(formData?.education) &&
                      formData?.education?.map((item, index) => (
                        <div key={index}>
                          <p>
                            {Array.isArray(degreeOptions) &&
                              degreeOptions.find(
                                (option) => option.value == item.degree_id
                              )?.label}
                            - {item?.field}
                          </p>
                          <p>{item?.university}</p>
                          <p>
                            {item?.from_year} - {item?.to_year}
                          </p>
                        </div>
                      ))}
                  </div>
                )}
              </>
            )}

            {(formData?.expert || formData?.iam == 1) && (
              <>
                {formData?.iam == 2 ? (
                  ""
                ) : (
                  <div className="about-expert">
                    <h6>
                      Experience
                      <a>
                        <img
                          onClick={() => setModelEmployment(true)}
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                          alt=""
                        />
                      </a>
                    </h6>
                    {Array.isArray(formData?.experience) &&
                      formData?.experience?.map((item, index) => (
                        <div key={index}>
                          <p>
                            {decodeHtml(item?.designation)} - {item?.company}
                          </p>
                          <p>
                            <YearRange
                              fromYear={item?.from_year}
                              toYear={item?.to_year}
                            />
                          </p>
                        </div>
                      ))}
                  </div>
                )}
              </>
            )}
            {(formData?.expert || formData?.iam == 1) && (
              <>
                {formData?.iam == 2 ? (
                  ""
                ) : (
                  <div className="about-expert">
                    <h6>
                      CV & job preferences
                      <a>
                        <img
                          onClick={() => setModelPrice(true)}
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                          alt=""
                        />
                      </a>
                    </h6>
                    <p>
                      $
                      {formData?.expert
                        ? formData?.expert?.price_per_hour == ""
                          ? formData?.price_per_hour || 0
                          : formData?.expert?.price_per_hour || 0
                        : formData?.price_per_hour || 0}
                      /hour
                    </p>
                    <p>
                      $
                      {formData?.expert
                        ? formData?.expert?.price_per_month == ""
                          ? formData?.price_per_month || 0
                          : formData?.expert?.price_per_month || 0
                        : formData?.price_per_month || 0}
                      /month
                    </p>
                  </div>
                )}
              </>
            )}
            {(formData?.company || formData?.iam == 2) && (
              <>
                {formData?.iam == 1 ? (
                  ""
                ) : (
                  <div className="about-expert">
                    <h6>
                      Job preferences
                      <a>
                        <img
                          onClick={() => setModelCompanyPrice(true)}
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                          alt=""
                        />
                      </a>
                    </h6>
                    <p>
                      $
                      {formData?.company
                        ? formData?.company?.price_per_hour == ""
                          ? formData?.price_per_hour || 0
                          : formData?.company?.price_per_hour
                        : formData?.price_per_hour || 0}
                      /hour
                    </p>
                    <p>
                      $
                      {formData?.company
                        ? formData?.company?.price_per_month == ""
                          ? formData?.price_per_month || 0
                          : formData?.company?.price_per_month
                        : formData?.price_per_month || 0}
                      /month
                    </p>
                  </div>
                )}
              </>
            )}
            <div className="about-expert">
              <h6>
                Bank Details
                <a onClick={() => setModelBank(true)}>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </h6>
              <p>Bank Name - {formData?.bank_details?.bank_name}</p>
              <p>Account No. - {maskAccountNumber(formData?.bank_details?.account_number)}</p>
              <p>IFSC Code - {formData?.bank_details?.ifsc_code}</p>
              <p>Swift code - {formData?.bank_details?.swift_code}</p>
              <p>
                Account holder - {formData?.bank_details?.account_holder_name}
              </p>
            </div>
          </div>
          <div className="col-lg-9 col-md-8 expert-second-right">
            {edittype == 1 && formData?.expert && (
              <>
                <h4 className="d-flex justify-content-between align-items-center">
                  About Expert
                </h4>
                <CustomReactQuillDescription
                  value={
                    formData?.expert ? formData?.expert?.about : formData?.about
                  }
                />
                <h4 className="d-flex justify-content-between align-items-center">
                  {decodeHtml(formData?.expert
                    ? formData?.expert?.designation
                    : formData?.designation)}
                  <a>
                    <img
                      onClick={() => setModelExpertAbout(true)}
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                      alt=""
                    />
                  </a>
                </h4>

              </>
            )}

            {edittype == 2 && formData?.iam == 1 && (
              <>
                <h4 className="d-flex justify-content-between align-items-center">
                  About Expert
                  <a>
                    <img
                      onClick={() => setModelExpertAbout(true)}
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                      alt=""
                    />
                  </a>
                </h4>
                <h4>
                  {decodeHtml(formData?.expert
                    ? formData?.expert?.designation == ""
                      ? formData?.designation
                      : formData?.expert?.designation
                    : formData?.designation)}
                </h4>
                <CustomReactQuillDescription
                  value={
                    formData?.expert
                      ? formData?.expert?.about == ""
                        ? formData?.about
                        : formData?.expert?.about
                      : formData?.about
                  }
                />
              </>
            )}

            {(formData?.company || formData?.iam == 2) && (
              <>
                {formData?.iam == 1 ? (
                  ""
                ) : (
                  <div>
                    <h4 className="d-flex justify-content-between align-items-center">
                      About company
                      <a>
                        <img
                          onClick={() => setModelCompanyAbout(true)}
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                          alt=""
                        />
                      </a>
                    </h4>
                    <CustomReactQuillDescription
                      value={
                        formData?.company
                          ? formData?.company?.about == ""
                            ? formData?.about
                            : formData?.company?.about
                          : formData?.company?.about
                      }
                    />
                  </div>
                )}
              </>
            )}

            {/* {(formData?.company || formData?.iam == 2) && (
              <>
                {formData?.iam == 1 ? (
                  ""
                ) : (
                  <div className="expert-sub-sec">
                    <div className="expert-heading">
                      <h6>Industries fefe</h6>
                      <a>
                        <img
                          onClick={() => setModelIndustry(true)}
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="skills">
                      {Array.isArray(formData?.industries) &&
                        formData?.industries?.map((item, index) => (
                          <p key={index}>{item?.title}</p>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )} */}

            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>Competencies </h6>
                <a>
                  <img
                    onClick={() => setModalSkills(true)}
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/edit.svg`}
                    alt=""
                  />
                </a>
              </div>
              <div className="skills">
                {Array.isArray(formData?.skills) &&
                  formData?.skills?.map((item, index) => (
                    <p key={index}>{decodeHtml(item?.title)}</p>
                  ))}
              </div>
            </div>
            {Array.isArray(formData?.work_sample) &&
              formData?.work_sample?.length > 0 && (
                <div className="expert-sub-sec">
                  <div className="expert-heading">
                    <h6>Work samples</h6>
                    {edittype == 1 && (
                      <button className="btn" onClick={() => navigate(`/${lan}/dashboard/manageportfolio`)}  >
                        View all
                      </button>
                    )}
                  </div>
                  <div className="row exp-row">
                    {Array.isArray(formData?.work_sample) &&
                      formData?.work_sample?.map((item, index) => (
                        <div key={index} className="col-lg-4 col-md-6  expert-img">
                          <div className="" onClick={() => navigate(`/${lan}/worksample/${item.id}`)} >
                            <DisplayFileProper item={{ file: item?.files[0]?.file }} />
                            <h5>{item?.title}</h5>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            {Array.isArray(formData?.bxp) && formData?.bxp?.length > 0 && (
              <div className="expert-sub-sec">
                <div className="expert-heading">
                  <h6>One time service (OTS)</h6>
                  {edittype == 1 && (
                    <button
                      className="btn"
                      onClick={() =>
                        navigate(`/${lan}/dashboard/myotsproducts`)
                      }
                    >
                      View all
                    </button>
                  )}
                </div>
                <div className="row exp-row">
                  {Array.isArray(formData?.bxp) &&
                    formData?.bxp?.map((item, index) => (
                      <div key={index} className="col-lg-4 col-md-6  expert-img" onClick={() => { navigate(`/${lan}/packageddetails/${item.id}`); }}>
                        <DisplayFileProper item={{ file: (Array.isArray(item?.files) && item?.files[0]?.file) }} className="w-100" />
                        <h5>{item?.title}</h5>
                        <CustomReactQuillDescription
                          value={item?.description}
                        />
                        <h5>$ {formatNumberWithCommas(item?.price)}</h5>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {edittype == 1 && (
              <>
                <RatingReviewsComponent formData={formData} />
              </>
            )}
          </div>
        </div>
      </div>

      <Modal
        className="popupmodal yes-no"
        isOpen={industryModal}
        toggle={() => setIndustryModal(!industryModal)}
      >
        <ProfileIndustryModal
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModalLanguage={setIndustryModal}
        />
      </Modal>
      <Modal
        className="popupmodal yes-no setCatsubcat-modal"
        isOpen={catsubcat}
      >
        <ProfileModelCategoerySubcategory
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setCatsubcat={setCatsubcat}
        />
      </Modal>

      <Modal className="popupmodal yes-no" isOpen={modalSkills}>
        <ProfileModelSkills
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModalSkills={setModalSkills}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modalportfolio}>
        <ProfileModelPortfolio
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModalPortfolio={setModalPortfolio}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modallanguage}>
        <ProfileModelLanguage
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModalLanguage={setModalLanguage}
        />
      </Modal>
      <Modal className="popupmodal yes-no modal-width" isOpen={modelAcademic}>
        <ProfileModelAcademicInfo
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelAcademic={setModelAcademic}
        />
      </Modal>
      <Modal className="popupmodal yes-no modal-width" isOpen={modelEmployment}>
        <ProfileModelEmployment
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelEmployment={setModelEmployment}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelAbout}>
        <ProfileModelAbout
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelAbout={setModelAbout}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelExpertAbout}>
        <ProfileModelExpertAbout
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelExpertAbout={setModelExpertAbout}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelCompanyAbout}>
        <ProfileModelCompanyAbout
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelCompanyAbout={setModelCompanyAbout}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelBank}>
        <ProfileModelBankDetails
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelBank={setModelBank}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelImage}>
        <ProfileModelImage
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelImage={setModelImage}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelIndustry}>
        <ProfileModelIndustry
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelIndustry={setModelIndustry}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelPrice}>
        <ProfileModelPrice
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelPrice={setModelPrice}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelProfile}>
        <ProfileModelProfile
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelProfile={setModelProfile}
        />
      </Modal>
      <Modal className="popupmodal yes-no" isOpen={modelCompanyPrice}>
        <ProfileModelCompanyPrice
          edittype={edittype}
          formData={formData}
          setFormData={setFormData}
          setModelCompanyPrice={setModelCompanyPrice}
        />
      </Modal>
    </div>
  );
}

// PREEMPTIVE HMR BURST
